import classNames from "classnames";
import React from "react";
import Menu from "../Menu";
import { type RichEditorToolbarButtons } from "../types";

type Props = {
  className?: string;
  isDisabled?: boolean;
  dropdownClassName?: string;
  menu: RichEditorToolbarButtons;
};
const Toolbar = React.forwardRef(({ className, ...props }: Props, ref: React.RefObject<HTMLDivElement>) => (
  <Menu {...props} ref={ref} className={classNames(className, "toolbar")} />
));
export default Toolbar;
